const TOKEN_KEY = 'provider_token';

export function getProviderToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setProviderToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearProviderToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function isProviderLoggedIn() {
  return !!getProviderToken();
}

async function fetchProvider(path, options = {}) {
  const token = getProviderToken();
  const res = await fetch(`${path}`, {
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...options.headers },
    ...options,
  });
  if (!res.ok) {
    if (res.status === 401) {
      clearProviderToken();
      window.location.href = '/provider/login';
    }
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error(err.detail || err.message || 'API Fehler');
  }
  return res.json();
}

export const providerApi = {
  register: (data) => fetchProvider('/api/provider/register', { method: 'POST', body: JSON.stringify(data) }),
  login: (email, password) => fetchProvider('/api/provider/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  me: () => fetchProvider('/api/provider/me'),
  updateProfile: (data) => fetchProvider('/api/provider/profile', { method: 'PUT', body: JSON.stringify(data) }),
  listDeals: () => fetchProvider('/api/provider/deals'),
  createDeal: (data) => fetchProvider('/api/provider/deals', { method: 'POST', body: JSON.stringify(data) }),
  updateDeal: (id, data) => fetchProvider(`/api/provider/deals/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteDeal: (id) => fetchProvider(`/api/provider/deals/${id}`, { method: 'DELETE' }),
  updatePrices: (prices) => fetchProvider('/api/provider/prices', { method: 'PUT', body: JSON.stringify({ prices }) }),
  generateApiKey: () => fetchProvider('/api/provider/api-key', { method: 'POST' }),
  listInvoices: () => fetchProvider('/api/provider/invoices'),
};
